import { render, staticRenderFns } from "./BaseRadioForm.vue?vue&type=template&id=d88b664a&scoped=true"
import script from "./BaseRadioForm.vue?vue&type=script&lang=js"
export * from "./BaseRadioForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88b664a",
  null
  
)

export default component.exports